import axios from '../helpers/axios-auth';

class notificationService {
  getNotifications(page, size) {
    if (!page) {
      page = 0;
    } else {
      page -= 1;
    }
    if (!size) {
      size = 50;
    }
    let params = {
      page: page,
      size: size
    };

    return axios.get('/auth/notifications', { params });
  }

  getGuestNotifications(page, size) {
    if (!page) {
      page = 0;
    } else {
      page -= 1;
    }
    if (!size) {
      size = 50;
    }
    let params = {
      page: page,
      size: size
    };

    return axios.get('/guest-notifications', { params });
  }

  getNewNotificationCount() {
    return axios.get('/auth/notifications-count');
  }
}

export default new notificationService();
